import { getSafeLocation } from '../utils/safeLocation';

const useQuery = () => getSafeLocation().searchParams;

export default useQuery;
